/*
 * @Description: 用户登录或注册api
 */

import request from '@/utils/request'

/**
 * 登录接口
 */
export const login = async (data) => request({
	url: "/login",
	method: "POST",
	data,
})

/**
 * 注册
 */
export const register = async (data) => request({
	url: "/register",
	method: "POST",
	data
})

/**
 * 将登录信息通知管理者
 */
export const sendWxMsgGet = async (openid, keyword, data) => request({
	url: "https://xcx11.5izg.bj.cn/tools/post.ashx?act=wx_template_notice&openid=" + openid +
		"&notice_name=会员充值提醒&first_line=&end_line=&keyword=" + keyword +
		"&s_manager=13366682206&kh=13366682206&order_no=&openUrl=&type=超管&name=超管",
	method: "GET",
	data
})